import { publicationMentionConfig } from "components/Quill/Mention/publication";
import { useCoreApi } from "providers/CoreApiProvider";
import { DiscussionBase } from "views/foundation/discussion/components/DiscussionBase";

export interface IDiscussionProps {
    publicationId: string;
    publicationTitle: string;
    readOnly: boolean;
    isDialog?: boolean;

    onUpdateCommentCounter?: (totalComments: number) => void;
}

/**
 * Comentários de publicações.
 * @param props
 */
export const CommentBox: React.FC<IDiscussionProps> = (props) => {

    const { publicationId, publicationTitle, readOnly, onUpdateCommentCounter, isDialog } = props;
    const api = useCoreApi();

    return (
        <DiscussionBase
            referenceId={publicationId}
            title={publicationTitle}
            readOnly={readOnly}
            dialogMode={isDialog}
            counterMode="answers"
            configPeopleMention={publicationMentionConfig}
            onUpdateCommentCounter={onUpdateCommentCounter}
            onGetDiscussions={(parentId, startSequenceNum, take, filter, orderBy, discussionId) =>
                api.v1.knowledgeDiscussion.publicationComments({
                    parentId,
                    startSequenceNum,
                    take,
                    filter,
                    orderBy,
                    discussionId,
                    publicationId
                })
            }
            onPostNew={({ parentId, replyId, message }) =>
                api.v1.knowledgeDiscussion.createPublicationComment({
                    publicationId,
                    parentId,
                    replyId,
                    message
                })
            }
            onPostDelete={(discussionId) =>
                api.v1.knowledgeDiscussion.deletePublicationComment({
                    publicationId,
                    commentId: discussionId
                })
            }
            onPostUpdate={(discussionId, message, discussionType) =>
                api.v1.knowledgeDiscussion.updatePublicationComment({ discussionId, message, discussionType })
            }
            onPostLike={(discussionId, like) =>
                api.v1.knowledgeDiscussion.likePublicationComment({
                    publicationId,
                    commentId: discussionId,
                    like
                })
            }
        />
    );
};
